import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import { isAuthenticated } from "../../actions/auth";
import Login from "../views/auth/Login";

const UserRoute = ({ token, tipo, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated(token) ? <Component {...props} tipoUsuario={tipo} /> : <Login {...props} redirect={rest.location.pathname} />
      }
    />
  )
};

UserRoute.propTypes = {
  component: PropTypes.any.isRequired,
  token: PropTypes.string
};

function mapStateToProps(state) {
  return {
    token: state.user.token,
    tipo: (state.user.user) ? state.user.user.tipo : null
  };
}

export default connect(mapStateToProps)(UserRoute);
